import * as CSS from 'csstype';
import { Config } from '../utils/prop-config';
import { Length, t, Token, transforms } from '../utils';

export const transform: Config = {
  clipPath: true,
  transform: t.propT('transform', transforms.transform),
  transformOrigin: true,
  translateX: t.spaceT('--potion-translate-x'),
  translateY: t.spaceT('--potion-translate-y'),
  skewX: t.degreeT('--potion-skew-x'),
  skewY: t.degreeT('--potion-skew-y'),
  scaleX: t.prop('--potion-scale-x'),
  scaleY: t.prop('--potion-scale-y'),
  scale: t.prop(['--potion-scale-x', '--potion-scale-y']),
  rotate: t.degreeT('--potion-rotate'),
};

export interface TransformProps {
  /**
   * The CSS `transform` property
   */
  transform?: Token<CSS.Property.Transform | 'auto' | 'auto-gpu'>;
  /**
   * The CSS `transform-origin` property
   */
  transformOrigin?: Token<CSS.Property.TransformOrigin | number, 'sizes'>;
  /**
   * The CSS `clip-path` property.
   *
   * It creates a clipping region that sets what part of an element should be shown.
   */
  clipPath?: Token<CSS.Property.ClipPath>;
  /**
   * Translate value of an elements in the x-direction.
   * - Only works if `transform=auto`
   * - It sets the value of `--potion-translate-x`
   */
  translateX?: Token<Length>;
  /**
   * Translate value of an elements in the y-direction.
   * - Only works if `transform=auto`
   * - It sets the value of `--potion-translate-y`
   */
  translateY?: Token<Length>;
  /**
   * Sets the rotate value of the element
   */
  rotate?: Token<Length>;
  /**
   * Skew value of an elements in the x-direction.
   * - Only works if `transform=auto`
   * - It sets the value of `--potion-skew-x`
   */
  skewX?: Token<Length>;
  /**
   * Skew value of an elements in the y-direction.
   * - Only works if `transform=auto`
   * - It sets the value of `--potion-skew-y`
   */
  skewY?: Token<Length>;
  /**
   * Scale value of an elements in the x-direction.
   * - Only works if `transform=auto`
   * - It sets the value of `--potion-scale-x`
   */
  scaleX?: Token<Length>;
  /**
   * Scale value of an elements in the y-direction.
   * - Only works if `transform=auto`
   * - It sets the value of `--potion-scale-y`
   */
  scaleY?: Token<Length>;
  /**
   * Sets the scale value of the element
   */
  scale?: Token<Length>;
}
